export default __webpack_public_path__ + "static/media/banner-img.4cfa8956.jpg";